import { render, staticRenderFns } from "./ProjectManagerList.vue?vue&type=template&id=e2123018&"
import script from "./ProjectManagerList.vue?vue&type=script&lang=js&"
export * from "./ProjectManagerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports